var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 16.4999L12.1693 12.1691M12.1693 12.1691C13.3415 10.9969 14 9.40717 14 7.7495C14 6.09184 13.3415 4.50207 12.1693 3.32992C10.9972 2.15777 9.40741 1.49927 7.74975 1.49927C6.09208 1.49927 4.50231 2.15777 3.33016 3.32992C2.15802 4.50207 1.49951 6.09184 1.49951 7.7495C1.49951 9.40717 2.15802 10.9969 3.33016 12.1691C4.50231 13.3412 6.09208 13.9997 7.74975 13.9997C9.40741 13.9997 10.9972 13.3412 12.1693 12.1691Z",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/Loop.68e89cecc913cd5e37310cdfc1f3fe65.svg";
export { ForwardRef as ReactComponent };